import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { PaymentTaskExpenseAccountItemRow } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskExpenseAccountItemEditForm/PaymentTaskExpenseAccountItemsElement/PaymentTaskExpenseAccountItemRow';
import { useInvalidatePaymentTaskExpenseAccountItems } from '@/hooks/api/2350_payment_task_expense_account_items';
import { useDestroyPaymentTaskExpenseAccountItem } from '@/hooks/api/2380_destroy_payment_task_expense_account_item';
import { PaymentTaskExpenseAccountItem } from '@/hooks/api/models';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const PaymentTaskExpenseAccountItemsElement = ({
  paymentTaskExpenseAccountItems,
}: {
  paymentTaskExpenseAccountItems: PaymentTaskExpenseAccountItem[];
}) => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  const [delTarget, setDelTarget] = useState<PaymentTaskExpenseAccountItem>();
  const {
    mutate: destroyMutate,
    isSuccess: destroyIsSuccess,
    isPending: destroyIsPending,
  } = useDestroyPaymentTaskExpenseAccountItem();
  const { invalidate } = useInvalidatePaymentTaskExpenseAccountItems({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    purchase_order_id: Number(purchase_order_id),
    task_id: task!.id,
  });

  useEffect(() => {
    if (destroyIsSuccess) {
      invalidate();
    }
  }, [destroyIsSuccess]);

  useEffect(() => setShowLoading(destroyIsPending), [destroyIsPending]);

  const onDeleteClick = () => {
    setShowLoading(true);
    destroyMutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      purchase_order_id: Number(purchase_order_id),
      task_id: task!.id,
      id: delTarget!.id,
    });
  };

  if (paymentTaskExpenseAccountItems.length == 0) return <></>;

  return (
    <div className="table-responsive">
      <ModalConfirm modalId={`delConfirm`} okClicked={() => onDeleteClick()} message={'削除します。よろしいですか？'} />

      <table className="table align-items-center">
        <thead>
          <tr>
            <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2">費用科目</th>
            <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2 text-end" style={{ width: 150 }}>
              金額
            </th>
            <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2" style={{ width: 100 }}></th>
          </tr>
        </thead>
        <tbody>
          {paymentTaskExpenseAccountItems.map((d) => (
            <PaymentTaskExpenseAccountItemRow key={`pteai-${d.id}`} d={d} setDelTarget={setDelTarget} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
